// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { uiStateAction } from '../../../actions/app.action'
import { accountActionForGuestCheckout } from '../../../actions/auth.action'
import { fetchGuestSchoolStoresCall, guestCheckoutCall } from '../../../actions/enrollment.action'
import { countriesByOrgCall, statesCall } from '../../../actions/masterData.action'
import { fetchAppId, fetchPaymentGateways } from '../../../actions/payment.action'
import localStorageService from '../../../api/localStorageService'
import SchoolStore from '../../../components/sis/student/schoolStore/SchoolStore'
import { PAYMENT_TYPES } from '../../../helpers/constants'
import {
  selectMasterData,
  selectMetaData,
  selectPayment,
  selectSchool,
  selectUiState,
  selectUser,
} from '../../../helpers/selectors'
import { get, getSchoolUrl, isEmpty, noop } from '../../../helpers/utils'
import withRouteContext from '../../../hocs/RouterContextHOC'
import withStudentDetails from '../../../hocs/withStudentDetailHOC'

function SchoolStoresContainer({
  school,
  user,
  fetchGuestSchoolStoresCall,
  fetchPaymentGateways,
  fetchAppId,
  payment,
  countriesByOrgCall,
  masterData,
  statesCall,
  guestCheckoutCall,
  metadata,
  accountActionForGuestCheckout,
}) {
  const params = useParams()
  const [schoolStores, setSchoolStores] = useState([])
  const [selectedStores, setSelectedStores] = useState([])
  const [paymentGateways, setPaymentGateways] = React.useState([])
  const [selectedGateway, setSelectedGateway] = React.useState('')
  const [schooolCountries, setSchooolCountries] = useState([])
  const [states, setStates] = useState([])
  const [personalInforForm, setPersonalInfoForm] = React.useState(false)
  const [openPaymentPopup, setOpenPaymentPopup] = React.useState(false)
  const [formData, setFormData] = useState({})
  const getSchoolStoreList = function () {
    fetchGuestSchoolStoresCall(school.sch_school_public_id, (data) => {
      setSchoolStores(data)
    })
  }
  const onGatewaySelect = function (event) {
    setSelectedGateway(event.currentTarget.attributes['data-id'].value)
  }
  const getPaymentGateways = (amount) => {
    fetchPaymentGateways({ is_recurring: 0, is_onetime: 1, amount: amount }, (data) => {
      setPaymentGateways(data)
      setSelectedGateway(
        get(
          data.find((gateway) => gateway.gateway_master_alias === AUTHORIZENET),
          'id',
          ''
        )
      )
    })
  }

  const togglePersonalInfoForm = () => {
    setPersonalInfoForm(!personalInforForm)
  }

  const togglePaymentPopup = () => {
    setOpenPaymentPopup(!openPaymentPopup)
    setPersonalInfoForm(!personalInforForm)
  }

  const createGuestCheckout = () => {
    setOpenPaymentPopup(false)
    setPersonalInfoForm(false)
    const returnType = PAYMENT_TYPES.GUEST_CHECKOUT_SUCCESS
    const returnUrl = `${window.location.origin}${getSchoolUrl({
      ...params,
      to: returnType,
    })}`

    const cancelType = PAYMENT_TYPES.GUEST_CHECKOUT_FAILURE
    const cancelUrl = `${window.location.origin}${getSchoolUrl({
      ...params,
      to: cancelType,
    })}`

    const appId = get(
      paymentGateways.find((gateway) => gateway.id === parseInt(selectedGateway)),
      'app_id',
      ''
    )
    const values = {
      afc_ids: selectedStores,
      payment_gateway_configuration_id: parseInt(selectedGateway),
      return_url: returnUrl,

      cancel_url: `${window.location.origin}${getSchoolUrl({
        ...params,
        to: cancelUrl,
      })}`,
    }
    schoolStoreAddOn(appId, values)
  }

  const schoolStoreAddOn = function (appId, values) {
    guestCheckoutCall(
      appId,
      values,
      { school_realm_name: school.sch_school_public_id, ...formData },
      (approval_url) => {
        if (approval_url) {
          window.location = approval_url
        }
      },
      (err) => {
        const error = get(err, 'response.data.code', '')
        const customeMessage = get(err, 'response.data.customMessage.error', '')
        if (!isEmpty(error) && customeMessage === 'AR51_PAYMENT:ARB_NOT_SETTLE') {
          messageAction({
            title: 'error:errorPayment',
            subTitle: 'error:unsettledPrePaymentTransaction',
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        } else if (!isEmpty(error)) {
          messageAction({
            subTitle: mapGeneralErrors(error, 'error:errorPayment'),
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        } else {
          messageAction({
            title: 'error:errorPayment',
            subTitle: 'error:errorPaymentMessage',
            severity: MESSAGE_SEVERITIES.ERROR,
          })
        }
      }
    )
  }

  const searchStates = (countryCode) => {
    statesCall(
      countryCode,
      {
        q: '',
        sort_by: '',
        sort_order: '',
        page: 1,
        per_page: 1000,
        is_active: '',
      },
      (records) => {
        setStates(get(records, 'content', []))
      },
      null,
      false
    )
  }
  React.useEffect(() => {
    const updatedParams = { ...params, guest_customer: true }
    accountActionForGuestCheckout(
      updatedParams,
      () => {
        localStorageService.setDistrictSchool(params)
      },
      () => {
        localStorageService.clearDistrictSchool()
      }
    )
  }, [])
  React.useEffect(() => {
    if (!isEmpty(school)) {
      getSchoolStoreList()
      countriesByOrgCall(school.sch_urn, (data) => {
        setSchooolCountries(data)
      })
    }
  }, [school])

  React.useEffect(() => {
    if (school.sch_school_public_id && isEmpty(payment)) {
      fetchAppId()
    }
  }, [school.sch_school_public_id, payment])
  return (
    <SchoolStore
      schoolStores={schoolStores}
      selectedStores={selectedStores}
      setSelectedStores={setSelectedStores}
      user={user}
      getPaymentGateways={getPaymentGateways}
      onGatewaySelect={onGatewaySelect}
      school={school}
      paymentGateways={paymentGateways}
      selectedGateway={selectedGateway}
      masterData={masterData}
      schooolCountries={schooolCountries}
      searchStates={searchStates}
      createGuestCheckout={createGuestCheckout}
      setFormData={setFormData}
      states={states}
      setPersonalInfoForm={setPersonalInfoForm}
      togglePersonalInfoForm={togglePersonalInfoForm}
      personalInforForm={personalInforForm}
      openPaymentPopup={openPaymentPopup}
      togglePaymentPopup={togglePaymentPopup}
      metadata={metadata}
      setOpenPaymentPopup={setOpenPaymentPopup}
    />
  )
}

SchoolStoresContainer.propTypes = {
  uiState: PropTypes.object,
  uiStateAction: PropTypes.func,
  fetchAllProgramsCall: PropTypes.func,
  school: PropTypes.object,
  user: PropTypes.object,
  fetchGuestSchoolStoresCall: PropTypes.func,
  fetchPaymentGateways: PropTypes.func,
  fetchAppId: PropTypes.func,
  payment: PropTypes.object,
  masterData: PropTypes.object,
  countriesByOrgCall: PropTypes.func,
  statesCall: PropTypes.func,
  guestCheckoutCall: PropTypes.func,
  metadata: PropTypes.object,
  accountActionForGuestCheckout: PropTypes.func,
}

SchoolStoresContainer.defaultProps = {
  uiState: {},
  uiStateAction: noop,
  school: {},
  user: {},
  fetchGuestSchoolStoresCall: noop,
  fetchPaymentGateways: noop,
  fetchAppId: noop,
  payment: {},
  masterData: {},
  countriesByOrgCall: noop,
  statesCall: noop,
  guestCheckoutCall: noop,
  metadata: {},
  accountActionForGuestCheckout: noop,
}

const mapStateToProps = (state) => ({
  school: selectSchool(state),
  uiState: selectUiState(state),
  user: selectUser(state),
  payment: selectPayment(state),
  masterData: selectMasterData(state),
  metadata: selectMetaData(state),
})

export default withStudentDetails(
  withRouteContext(
    connect(mapStateToProps, {
      uiStateAction,
      fetchPaymentGateways,
      fetchGuestSchoolStoresCall,
      fetchAppId,
      countriesByOrgCall,
      statesCall,
      guestCheckoutCall,
      accountActionForGuestCheckout,
    })(SchoolStoresContainer)
  )
)
